// Ritorna la "home" dell'utente in base al ruolo:
// - operatore (saldatura) → dashboard operatore saldatrici
// - operatore_estrusione  → dashboard operatore estrusione
// - tutti gli altri (admin, ufficio, magazziniere, segreteria) → cruscotto
export function homeForRole(role) {
    if (role === "operatore") return "/produzione";
    if (role === "operatore_estrusione") return "/estrusione/produzione";
    return "/";
}
